import { enableES5 } from 'immer';
import { combineReducers } from 'redux';

import priceOfferList from './priceOfferList';
import sort from './sort';
import filter from './filter';

enableES5(); // This is to ensure immer works on IE, remove when we no longer need to support IE11.

const priceOfferListApp = combineReducers({
  priceOfferList,
  sort,
  filter,
});

export default priceOfferListApp;
